import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "001_initial",
  version: "1.0.0",
  sql: `
CREATE TABLE IF NOT EXISTS \`crm_organizations\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`name\` text NOT NULL,
	\`website\` text,
	\`industry\` text,
	\`employee_count\` text,
	\`annual_revenue\` real,
	\`address\` text,
	\`city\` text,
	\`province\` text,
	\`postal_code\` text,
	\`country\` text DEFAULT 'TH',
	\`phone\` text,
	\`email\` text,
	\`customer_id\` text,
	\`remarks\` text,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text
);
CREATE TABLE IF NOT EXISTS \`crm_contacts\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`salutation\` text,
	\`first_name\` text,
	\`last_name\` text,
	\`full_name\` text,
	\`job_title\` text,
	\`email\` text,
	\`phone\` text,
	\`mobile\` text,
	\`line_id\` text,
	\`organization_id\` text,
	\`customer_id\` text,
	\`remarks\` text,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text,
	FOREIGN KEY (\`organization_id\`) REFERENCES \`crm_organizations\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE INDEX IF NOT EXISTS \`contact_company_idx\` ON \`crm_contacts\` (\`company_id\`);
CREATE INDEX IF NOT EXISTS \`contact_company_org_idx\` ON \`crm_contacts\` (\`company_id\`,\`organization_id\`);
CREATE TABLE IF NOT EXISTS \`crm_lead_sources\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`name\` text NOT NULL,
	\`sort_order\` integer DEFAULT 0,
	\`is_active\` integer DEFAULT 1
);
CREATE TABLE IF NOT EXISTS \`crm_lost_reasons\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`name\` text NOT NULL,
	\`sort_order\` integer DEFAULT 0,
	\`is_active\` integer DEFAULT 1
);
CREATE TABLE IF NOT EXISTS \`crm_leads\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`first_name\` text,
	\`last_name\` text,
	\`full_name\` text,
	\`email\` text,
	\`phone\` text,
	\`mobile\` text,
	\`line_id\` text,
	\`organization_name\` text,
	\`job_title\` text,
	\`website\` text,
	\`status\` text DEFAULT 'new' NOT NULL,
	\`doc_status\` integer DEFAULT 0 NOT NULL,
	\`workflow_id\` text,
	\`current_state_key\` text,
	\`source\` text,
	\`score\` integer DEFAULT 0,
	\`assigned_to\` text,
	\`converted_deal_id\` text,
	\`converted_contact_id\` text,
	\`converted_organization_id\` text,
	\`converted_at\` text,
	\`remarks\` text,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text,
	FOREIGN KEY (\`workflow_id\`) REFERENCES \`workflow_workflows\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE INDEX IF NOT EXISTS \`lead_company_status_idx\` ON \`crm_leads\` (\`company_id\`,\`status\`,\`created_at\`);
CREATE INDEX IF NOT EXISTS \`lead_company_assigned_idx\` ON \`crm_leads\` (\`company_id\`,\`assigned_to\`);
CREATE TABLE IF NOT EXISTS \`crm_deals\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`deal_no\` text,
	\`company_id\` text NOT NULL,
	\`name\` text NOT NULL,
	\`contact_id\` text,
	\`organization_id\` text,
	\`status\` text DEFAULT 'open' NOT NULL,
	\`doc_status\` integer DEFAULT 0 NOT NULL,
	\`workflow_id\` text,
	\`current_state_key\` text,
	\`lost_reason_id\` text,
	\`amount\` real DEFAULT 0,
	\`currency\` text DEFAULT 'THB',
	\`probability\` integer DEFAULT 0,
	\`expected_close_date\` text,
	\`closed_at\` text,
	\`assigned_to\` text,
	\`source\` text,
	\`lead_id\` text,
	\`customer_id\` text,
	\`invoice_id\` text,
	\`quotation_id\` text,
	\`remarks\` text,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text,
	FOREIGN KEY (\`contact_id\`) REFERENCES \`crm_contacts\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`organization_id\`) REFERENCES \`crm_organizations\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`workflow_id\`) REFERENCES \`workflow_workflows\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE INDEX IF NOT EXISTS \`deal_company_status_idx\` ON \`crm_deals\` (\`company_id\`,\`status\`,\`created_at\`);
CREATE INDEX IF NOT EXISTS \`deal_company_assigned_idx\` ON \`crm_deals\` (\`company_id\`,\`assigned_to\`);
CREATE TABLE IF NOT EXISTS \`crm_activities\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`reference_type\` text,
	\`reference_id\` text,
	\`type\` text,
	\`title\` text,
	\`description\` text,
	\`due_date\` text,
	\`is_done\` integer DEFAULT 0,
	\`completed_at\` text,
	\`assigned_to\` text,
	\`phone_number\` text,
	\`call_direction\` text,
	\`call_outcome\` text,
	\`call_duration\` integer,
	\`created_by\` text,
	\`created_at\` text NOT NULL,
	\`updated_at\` text NOT NULL
);
  `.trim(),
};
